import { LayoutWrapper } from '@bridebook/web/components/wedding-website/view-mode/layouts-v2/components/layout-wrapper';
import { TopDesktopAccent } from './components/top-desktop-accent';
import { FontPair } from '@bridebook/web/components/wedding-website/view-mode/layouts-v2/config/font-config';
import { Palette } from '@bridebook/web/components/wedding-website/view-mode/layouts-v2/config/palette-config';
import { ThemeProvider } from '@bridebook/web/components/wedding-website/view-mode/layouts-v2/config/theme-provider';
import { SectionsWithDividers } from '@bridebook/web/components/wedding-website/view-mode/layouts-v2/layout-primary/components/sections-with-dividers';

type Props = {
  palette: Palette;
  fontPair: FontPair;
};

export const WeddingWebsitePrimary = ({ palette, fontPair }: Props) => (
  <ThemeProvider
    palette={palette}
    fontPair={fontPair}
    preloadAllFonts
    className="@container w-full">
    <LayoutWrapper>
      <TopDesktopAccent />
      <SectionsWithDividers />
    </LayoutWrapper>
  </ThemeProvider>
);
